import {Box, Burger, Combobox, Flex, Image} from "@mantine/core";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Store} from "../redux/Store";
import {mobileNavBarActions} from "../redux/slices/MobileNavBarSlice";


// TODO: Implement Theme

function HeaderComponent() {


    const opened = useSelector((state: Store) => state.mobileNavBar)
    const dispatch = useDispatch()
    return (
        <Box h={{base: 50, md: 50}} p="md">
            <Flex align={"center"} h={"100%"}>
                    <Burger
                        opened={opened}
                        onClick={() => dispatch(mobileNavBarActions.switch())}
                        size="sm"
                        //color={theme.colors.gray[6]}
                        mr="md"
                    />
                <Image src={"/assets/Logo Outletstocks.png"} w={270} />
            </Flex>
        </Box>
    )
}

export default HeaderComponent;